<template>
  <footer>
    <div class="footer-logo"><Logo /></div>
    <div class="footer-meta">
      <div class="footer-copy">© {{ year }} Archestor Kft. — {{ m.footer.rights }}</div>
      <div class="footer-legal-links">
        <button type="button" class="footer-cookie-link" @click="openNotice">
          {{ m.footer.cookieNotice }}
        </button>
        <button type="button" class="footer-cookie-link" @click="openBanner">
          {{ m.footer.cookieSettings }}
        </button>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
const year = new Date().getFullYear()
const { messages: m } = useI18n()
const { openBanner } = useCookieConsent()
const { openNotice } = useCookieNotice()
</script>